import { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const skills = [
  "SYSTEMS ARCHITECTURE",
  "APPLE ECOSYSTEM",
  "CYBERSECURITY",
  "INFRASTRUCTURE",
  "REAL ESTATE TECH",
  "DIGITAL TRANSFORMATION",
  "ENTERPRISE SOLUTIONS",
  "INTERNATIONAL OPERATIONS",
];

export const Marquee = () => {
  const marqueeRef = useRef(null);
  const track1Ref = useRef(null);
  const track2Ref = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      // First track - moving left
      gsap.to(track1Ref.current, {
        xPercent: -50,
        duration: 20,
        ease: "none",
        repeat: -1,
      });

      // Second track - moving right
      gsap.to(track2Ref.current, {
        xPercent: 50,
        duration: 20,
        ease: "none",
        repeat: -1,
      });

      // Speed up on scroll
      ScrollTrigger.create({
        trigger: marqueeRef.current,
        start: "top bottom",
        end: "bottom top",
        onUpdate: (self) => {
          const velocity = self.getVelocity() / 100;
          gsap.to([track1Ref.current, track2Ref.current], {
            skewX: velocity * 0.05,
            duration: 0.5,
            ease: "power2.out"
          });
        }
      });

    }, marqueeRef);

    return () => ctx.revert();
  }, []);

  const renderItems = () => (
    <>
      {[...skills, ...skills].map((skill, index) => (
        <span
          key={index}
          className="inline-flex items-center gap-8 px-8 text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-transparent whitespace-nowrap"
          style={{ WebkitTextStroke: '1px rgba(10, 10, 10, 0.3)' }}
        >
          {skill}
          <span className="w-3 h-3 bg-steel rounded-full" />
        </span>
      ))}
    </>
  );

  return (
    <section
      ref={marqueeRef}
      className="py-16 md:py-24 bg-concrete/30 overflow-hidden border-y border-border/50"
    >
      {/* Track 1 */}
      <div className="mb-8 overflow-hidden">
        <div ref={track1Ref} className="flex whitespace-nowrap">
          {renderItems()}
        </div>
      </div>

      {/* Track 2 - reverse */}
      <div className="overflow-hidden">
        <div ref={track2Ref} className="flex whitespace-nowrap" style={{ transform: 'translateX(-50%)' }}>
          {renderItems()}
        </div>
      </div>
    </section>
  );
};

export default Marquee;
